// extracted by mini-css-extract-plugin
module.exports = {"container":"e_F-","hasBadge":"e_G-","bottomLine":"e_H-","imageContainer":"e_I-","image":"e_J-","header":"e_K-","title":"e_L-","score":"e_M-"};